<style scoped>
.btn {
  margin-top: 0.8vh;
}

.v-menu__content {
  max-width: 300px;
}
</style>

<template>
  <v-container fluid
    style="background-color: #154985; display: flex; align-items: center; justify-content: space-between;">
    <v-row>
      <v-col cols=2>
        <v-select v-model="Projet" :items="listProjet" density="compact" v-on:update:model-value="clickRecherche()" dense
          outlined hide-details label="Projet" background-color="#FFFFFF" clearable
          style="border-color: #FFFFFF !important; color: #FFFFFF !important;"></v-select>
      </v-col>

      <v-col cols=2>
        <v-select v-model="porteurProjet" :items="listPorteurProjet" v-on:update:model-value="clickRecherche()"
          density="compact" dense outlined hide-details label="Porteur de Projet" background-color="#FFFFFF" clearable
          style="border-color: #FFFFFF !important; color: #FFFFFF !important;"></v-select>
      </v-col>

      <v-col cols=2>
        <v-select v-model="Villes" :items="listCities.sort()" v-on:update:model-value="clickRecherche()" density="compact"
          dense outlined hide-details label="Villes" background-color="#FFFFFF" clearable
          style="border-color: #FFFFFF !important; color: #FFFFFF !important;"></v-select>
      </v-col>

      <v-col cols=2>
        <v-select v-model="statut" :items="listStatut" v-on:update:model-value="clickRecherche()" density="compact" dense
          outlined hide-details label="Statut" background-color="#FFFFFF" clearable
          style="border-color: #FFFFFF !important; color: #FFFFFF !important;"></v-select>
      </v-col>


      <v-col cols="2">
        <v-select v-model="year" :items="listAnnee" density="compact" v-on:update:model-value="clickRecherche()" dense
          outlined hide-details label="Année de démarrage" background-color="#FFFFFF" clearable
          style="border-color: #FFFFFF !important; color: #FFFFFF !important;"></v-select>
      </v-col>
      <v-col cols="2">
        <v-select v-model="typo" :items="listTypologies" density="compact" v-on:update:model-value="clickRecherche()"
          dense outlined hide-details label="Typologie" background-color="#FFFFFF" clearable
          style="border-color: #FFFFFF !important; color: #FFFFFF !important;"></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  props: {
    datas: { type: Array, default: function () { return [] } }
  },

  data: () => ({
    listStatut: ['En cours', 'Terminé'],
    Projet: null,
    Villes: null,
    porteurProjet: null,
    statut: null,
    year: null,
    typo: null,
  }),

  computed: {

    listCities() {
      if (this.datas && this.datas.length !== 0) {
        const checkDouble = []; 
        return this.datas.reduce((item, entry) => {
          if (entry["Situation géographique"] && !checkDouble.includes(entry["Situation géographique"])) {
            item.push(entry["Situation géographique"]);
            checkDouble.push(entry["Situation géographique"]);
          }
          return item;
        }, []);
      } else {
        return [];
      }
    },

    listProjet() {
      if (this.datas && this.datas.length !== 0) {
        let listProjet = [];
        const sortedList = this.datas.forEach((item) => {
          if (item["Projet"] && item["Projet"] != "") {
            listProjet.push(item["Projet"])
          }

        })
        listProjet.sort();
        return listProjet
      }
    },

    listAnnee() {
      if (this.datas && this.datas.length !== 0) {
        const checkDouble = [];
        const years = this.datas.reduce((item, entry) => {
          const year = new Date(entry["Date de départ"]).getFullYear();
          if (year && !checkDouble.includes(year)) {
            item.push(year);
            checkDouble.push(year);
          }
          return item;
        }, []);
        years.sort((a, b) => a - b);
        return years;
      } else {
        return [];
      }
    },

    listPorteurProjet() {
    if (this.datas && this.datas.length !== 0) {
        const checkDouble = [];
        const sortedList = this.datas.reduce((item, entry) => {
            if (entry["Porteur(s) du projet"] && entry["Situation géographique"] && !checkDouble.includes(entry["Porteur(s) du projet"])) {
                item.push(entry["Porteur(s) du projet"]);
                checkDouble.push(entry["Porteur(s) du projet"]);
            }
            return item;
        }, []);
        sortedList.sort((a, b) => {
            const aIsSpecial = !/[a-zA-Z]/.test(a[0]);
            const bIsSpecial = !/[a-zA-Z]/.test(b[0]);
            if (aIsSpecial && !bIsSpecial) {
                return -1; 
            } else if (!aIsSpecial && bIsSpecial) {
                return 1; 
            } else {
               return a.localeCompare(b);
            }
        });
        return sortedList;
    } else {
        return [];
    }
},

    listTypologies() {
      if (this.datas && this.datas.length !== 0) {
        const checkDouble = new Set(); 
        return this.datas.reduce((uniqueCategories, entry) => {
          if (entry["catégories de la technologie"]) {
            const categories = entry["catégories de la technologie"].split(',').map(cat => cat.trim()); // Diviser par la virgule et enlever les espaces vides
            categories.forEach(category => {
              if (!checkDouble.has(category)) { 
                uniqueCategories.push(category);
                checkDouble.add(category); 
              }
            });
          }
          return uniqueCategories;
        }, []);
      } else {
        return [];
      }
    },

    selectedFiltersForProjetcCO2() {
      return {
        "Projet": this.Projet,
        "statut": this.statut,
        "Date de départ": this.year,
        "Situation géographique": this.Villes,
        "Porteur(s) du projet": this.porteurProjet,
        "catégories de la technologie": this.typo,
      }
    },

    notNullFilter() {
      let notNullFilter = {};
      let tabKeys = Object.keys(this.selectedFiltersForProjetcCO2);
      let tabvalues = Object.values(this.selectedFiltersForProjetcCO2);
      for (let i = 0; i < tabKeys.length; i++) {
        if (tabvalues[i] !== null) {
          let key = tabKeys[i];
          let value = tabvalues[i]
          notNullFilter = { ...notNullFilter, [key]: value }

        }
      }
      return notNullFilter;

    },


  },
  methods: {
    clickRecherche() {
      this.$emit("clickRecherche", this.notNullFilter)

    },



  },
}

</script>



